module.exports = __webpack_public_path__ + "img/contexity-logo-w.6df3423d.png";